import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
	Login: "[Login] Action",
	Logout: "[Logout] Action",
	Refresh: "[Refresh] Action",
	Register: "[Register] Action",
	UserRequested: "[Request User] Action",
	UserLoaded: "[Load User] Auth API"
};

// TODO: Remove mock
// const initialAuthState = {
// 	user: {
// 		name: "Guilherme de Prais",
// 		email: "guilherme.prais@gmail.com",
// 		password: "ADMIN",
// 		roles: ["USER", "ADMIN"]
// 	},
// 	authData: undefined
// };

const initialAuthState = {
	user: undefined,
	authData: {}
};

export const reducer = persistReducer(
	{ storage, key: "auth:mutant", whitelist: ["user", "authData"] },
	(state = initialAuthState, action) => {
		switch (action.type) {
			case actionTypes.Login: {
				const { authData, user } = action.payload;
				return { authData: {...state.authData, ...authData}, user };
			}

			case actionTypes.Refresh: {
				const { authData } = action.payload;
				return { ...state, authData };
			}

			case actionTypes.Register: {
				const { authData } = action.payload;
				return {
					authData,
					user: JSON.parse(process.env.REACT_APP_AUTH_USER_MOCK)
				};
			}

			case actionTypes.Logout: {
				routerHelpers.forgotLastLocation();
				return initialAuthState;
			}

			case actionTypes.UserLoaded: {
				const { user } = action.payload;

				return { ...state, user };
			}

			default:
				return state;
		}
	}
);

export const actions = {
	login: (authData, user) => ({
		type: actionTypes.Login,
		payload: { authData, user }
	}),
	refresh: authData => ({
		type: actionTypes.Refresh,
		payload: { authData }
	}),
	register: authData => ({
		type: actionTypes.Register,
		payload: { authData }
	}),
	logout: () => ({ type: actionTypes.Logout })
};

export function* saga() { }
